import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { CurrentUserService } from '@shared/services/current-user.service';
import { environment } from 'src/environments/environment';

export const InercyaOnlyGuard: CanActivateFn = () => {
  const currentUserService = inject(CurrentUserService);
  const router = inject(Router);
  const email = (currentUserService.user?.user?.userEmail || '').toLowerCase();
  const domain = (environment as any).internalEmailDomain || '@inercya.com';
  const isAllowed = email.endsWith(domain);
  if (!isAllowed) {
    void router.navigate(['/']);
    return false;
  }
  return true;
};
